module.exports = __webpack_public_path__ + "static/img/application10-2.b0a4b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application10-2.jpg
// module id = wVRt
// module chunks = 0